<!-- 订单详情 -->
<template>
  <div class="content">
    <!--  -->
    <div class="cont_body">
      <!-- 订单进度条 -->
      <div class="step">
        <el-steps :active="active" finish-status="success" :space="300">
          <el-step
            title="买家下单"
            :description="detailData.create_time"
          ></el-step>
          <el-step
            title="买家付款"
            :description="detailData.show_payment_time"
          ></el-step>
          <el-step
            title="商家发货"
            :description="detailData.show_ship_time"
          ></el-step>
          <el-step
            title="交易完成"
            :description="detailData.show_confirm_time"
          ></el-step>
          <el-step title="已评价" description=""></el-step>
        </el-steps>
      </div>
      <!-- 配送信息 -->
      <div class="message">
        <ul class="message_left">
          <li>配送信息</li>
          <li>
            配送方式：<span>{{
              detailData.ship_type == 1
                ? "快递发货"
                : detailData.ship_type == 2
                ? "门店自提"
                : "不需要物流"
            }}</span>
          </li>
          <li>配送时间：<span>立即送出</span></li>
          <li>
            用户昵称：
            <span v-if="detailData.ship_type == '1'">{{
              detailData.address.name
            }}</span>
            <span v-if="detailData.ship_type == '2'">{{
              detailData.lading.name
            }}</span>
            <span v-if="detailData.ship_type == '3'">{{
              detailData.user.name
            }}</span>
          </li>
          <li v-if="detailData.ship_type == '1'">
            收货信息
            <span
              >{{ detailData.address.area }}
              {{ detailData.address.address }}</span
            >
          </li>
          <li>
            备注信息：<span>{{ detailData.message }}</span>
          </li>
        </ul>
        <ul class="message_right">
          <li>
            订单状态：<span>{{ detailData.show_text_status }}</span>
          </li>
          <li style="font-size:14px" v-if="detailData.pay_amount">
            实收金额：<span>{{ detailData.pay_amount }}</span>
          </li>
          <!-- <li>买家已付款，请尽快发货</li> -->
          <li>
            <el-button type="primary" plain @click="editPrice()" v-if="detailData.text_status == 1">修改价格</el-button>
            <el-button type="primary" plain @click="sendGoodsButton()" v-if="detailData.text_status == 2">发货</el-button>
            <el-button @click="cancelOrderButton()" v-if="detailData.text_status == 1">取消订单</el-button>
            <el-button @click="signButton()">标记</el-button>
          </li>
          <li>
            标记内容：
            <span class="iconfont iconqizi_icon" :style="signColor" v-if="detailData.tag_content" style="margin-right:5px"></span>
            <span>{{ detailData.tag_content }}</span>
          </li>
        </ul>
      </div>
      <div class="message" v-if="showTable">
        <ul class="message_left">
          <li>订单信息</li>
          <li class="info_li">
            订单编号：<span>{{ detailData.ordersn }}</span> 订单来源：<span>{{
              detailData.show_source
            }}</span>
            订单类型：<span>{{
              detailData.order_type == "1" ? "普通订单" : "拼团订单"
            }}</span>
          </li>
          <TableProductDetails
            :OrderSn="detailData.ordersn"
            :ShowOption="false"
            :ReadOnly="true"
          ></TableProductDetails>
        </ul>
      </div>
    </div>
    <!-- 发货弹窗 -->
    <SendGoods
      :showDialog="order_deliver_goods"
      :formData="sendForm"
      @close="closeSendDialog"
      @refresh="getOrderDetail()"
    ></SendGoods>
    <!-- 标记弹窗  -->
    <Sign
      :show_sign_dialog="dialog_remark"
      :formData="signForm"
      @close="closeSignDialog"
    ></Sign>
    <!-- 取消订单弹窗 -->
    <CancelOrder
      :showDialog="dialog_close_order"
      :OrderSn="editOrderSn"
      @closeDialog="closeDialog"
    ></CancelOrder>
    <!-- 修改价格弹窗 -->
    <el-dialog title="修改订单" :visible.sync="dialog_amend_order" width="60%">
      <TableProductDetails
        :OrderSn="editOrderSn"
        :ShowOption="false"
      ></TableProductDetails>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog_amend_order = false">取 消</el-button>
        <el-button type="primary" @click="dialog_amend_order = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderDetail } from "@/api/order";
import { mapGetters } from "vuex";
import TableProductDetails from "@Components/public/table_product_details";
import SendGoods from "./sendGoods";
import CancelOrder from "./closeOrder";
import Sign from "./editTag";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      active: 1, // 步骤条
      order_deliver_goods: false, // 发货弹窗
      detailData: {},
      sendForm: {},
      showTable: false,
      dialog_remark: false,
      signForm: {},
      dialog_close_order: false,
      editOrderSn: "",
      dialog_amend_order: false,
      signColor:"",
    };
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
    this.getOrderDetail();
  },
  methods: {
    sendGoodsButton() {
      this.sendForm = {
        ordersn: this.detailData.ordersn,
        create_time: this.detailData.create_time
      };
      if (this.detailData.ship_type == 1) {
        this.sendForm.ship_type = 1;
        this.sendForm.address =
          this.detailData.address.area + " " + this.detailData.address.address;
      } else {
        this.sendForm.address = "";
        this.sendForm.ship_type = 3;
      }
      this.order_deliver_goods = true;
    },
    closeSendDialog(rel) {
      this.order_deliver_goods = false;
      if (rel == 1) {
        this.getOrderDetail();
      }
    },
    // 修改价格弹窗
    editPrice() {
      this.editOrderSn = this.detailData.ordersn;
      this.dialog_amend_order = true;
    },
    // 标记弹窗
    signButton(sn) {
      this.signForm = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.detailData.ordersn,
        tag_content: this.detailData.tag_content,
        tag_color:this.detailData.tag_color,

      };
      this.dialog_remark = true;
    },
    // 关闭备注弹窗
    closeSignDialog(rel) {
      this.dialog_remark = false;
      if (rel == 1) {
        this.getOrderDetail();
      }
    },
    //取消订单
    cancelOrderButton(sn) {
      this.editOrderSn = sn;
      this.dialog_close_order = true;
    },
    //关闭取消订单弹窗
    closeDialog(rel) {
      this.dialog_close_order = false;
      if (rel == 1) {
        console.log(rel);
        this.getOrderDetail();
      }
    },
    getOrderDetail() {
      var data = {
        token: this.token,
        ordersn: this.$route.query.ordersn,
        app_id: this.app_id
      };
      OrderDetail(data).then(res => {
        this.detailData = Object.assign({}, res.data);
        console.log(this.detailData);
        this.showTable = true;
        this.detailData.show_source =
          this.detailData.source == 1
            ? "PC页面"
            : this.detailData.source == 2
            ? "H5页面"
            : "微信小程序";
        if (this.detailData.text_status == 1) {
          this.detailData.show_text_status = "待付款";
          this.active = 1;
        } else if (this.detailData.text_status == 2) {
          this.detailData.show_text_status = "待发货";
          this.active = 2;
        } else if (this.detailData.text_status == 3) {
          this.detailData.show_text_status = "待收货";
          this.active = 3;
        } else if (this.detailData.text_status == 4) {
          this.detailData.show_text_status = "待评价";
          this.active = 4;
        } else if (this.detailData.text_status == 5) {
          this.detailData.show_text_status = "已评价";
          this.active = 5;
        } else if (this.detailData.text_status == 6) {
          this.detailData.show_text_status = "已完成";
          this.active = 0;
        } else if (this.detailData.text_status == 7) {
          this.detailData.show_text_status = "已取消";
        }
        this.detailData.show_payment_time = this.detailData.payment_time ? this.formatTime(this.detailData.payment_time):"";
        this.detailData.show_ship_time = this.detailData.ship_time ? this.formatTime(this.detailData.ship_time):"";
        this.detailData.show_confirm_time = this.detailData.confirm_time ? this.formatTime(this.detailData.confirm_time):"";
        this.signColor = "color:" + this.detailData.tag_color;
      });
    },
    //时间格式化
    formatTime(time){
      var t = new Date(time*1000);
      var y = t.getFullYear();
      var m = t.getMonth() + 1;
      var d = t.getDate();
      var h = t.getHours();
      var mm = t.getMinutes();
      var s = t.getSeconds();
      m = m < 10? '0'+m : m;
      d = d < 10? '0'+d : d;
      h = h < 10? '0'+h : h;
      mm = mm < 10? '0'+mm : mm;
      s = s < 10? '0'+s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s;
    }
  },
  components: {
    TableProductDetails,
    SendGoods,
    CancelOrder,
    Sign
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  }
};
</script>
<style>
/* .el-step__icon is-text {
  width: 80px;
  height: 80px;
} */
</style>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 38px 0;
  height: 100%;
  .cont_body {
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    background-color: #fff;
    padding: 0 30px;
    height: 100%;
    /* 步骤条 */
    .step {
      height: 100px;
      .el-steps {
        margin-top: 20px;
      }
    }
    /* 信息框 */
    .message {
      display: flex;
      border-top: 1px solid #f1f1f1;
      ul {
        width: 70%;
        height: 220px;
        padding: 22px 0;
        li:nth-child(1) {
          font-weight: 800;
          font-size: 14px;
        }
        li {
          margin-bottom: 14px;
          span {
            margin-right: 30px;
          }
        }
      }
    }
  }
  /* 发货弹窗 */
  .deliver_goods {
    width: 100%;
    li {
      padding: 10px;
      span {
        margin-left: 20px;
        .el-input {
          width: 205px;
        }
      }
    }
  }
}
.el-steps {
  color: RED;
  .el-step {
    color: YELLOW;
    .el-step__head {
      .el-step__icon is-text {
        color: BLUE !important;
        .el-step__icon {
          color: BLUE;
          width: 84px !important;
          height: 84px !important;
        }
      }
    }
  }
}
</style>
